import type { CurrentUser } from '@gamble-chess/contracts';
import type { JSX } from 'react';

import { StandingRules } from '../components/StandingRules.tsx';
import { TrackedAccounts } from '../components/TrackedAccounts.tsx';

export interface SetupProps {
  readonly user: CurrentUser;
}

/** What the app watches and what it charges for: the two things worth configuring. */
export function Setup({ user }: SetupProps): JSX.Element {
  return (
    <>
      <TrackedAccounts />
      <StandingRules timeZone={user.timeZone} />
    </>
  );
}
